import {
  EquipmentGroupStId,
  FlexibleScope,
  InteractionScope,
  Equipment,
  Door,
  Elevator,
  GroupKind,
  ResiFlowInteractionScope
} from '../../../../types/types'
import { AssessmentErrors } from '../assessment/assessment-errors'
import { isValid, isValidForQuickTender } from './predicates'
export { isValid, isValidForQuickTender }
export * from './dto'

export interface AssessmentCriticality {
  readonly normal: FlexibleScope | null
  readonly critical: FlexibleScope | null
}

export interface ElevatorAndEscalatorCriticality {
  readonly elevator: AssessmentCriticality | null
  readonly escalator: AssessmentCriticality | null
  readonly resiflow: AssessmentCriticality | null
}

// TODO rename
export interface AssessmentGroup {
  readonly groupId: EquipmentGroupStId
  readonly name: string
  readonly groupKind: GroupKind
  readonly equipment: Equipment[]
  readonly criticalities: ElevatorAndEscalatorCriticality
}

export const getRatings = (criticality: AssessmentCriticality | null) => ({
  normal: criticality !== null ? criticality.normal : null,
  critical: criticality !== null ? criticality.critical : null
})

const validForFlexible = 'ValidForFlexible'
export class ValidForFlexible {
  readonly _tag: 'ValidForFlexible' = validForFlexible

  constructor(
    readonly groups: Record<EquipmentGroupStId, AssessmentGroup>,
    readonly interactionScope: InteractionScope | ResiFlowInteractionScope
  ) {}
}

// / ---

export interface OnlyDoorsAssessmentGroup {
  readonly groupId: EquipmentGroupStId
  readonly name: string
  readonly groupKind: 'doors'
  readonly doors: Door[]
  readonly criticalities: AssessmentCriticality
}

export class ValidForFlexibleDoors {
  readonly _tag: 'ValidForFlexibleDoors' = 'ValidForFlexibleDoors' as const

  constructor(
    readonly groups: Record<EquipmentGroupStId, OnlyDoorsAssessmentGroup>,
    readonly interactionScope: InteractionScope
  ) {}
}

// / ---

export class ValidForValueAddedServiceAddendum {
  readonly _tag: 'ValidForValueAddedServiceAddendum' = 'ValidForValueAddedServiceAddendum' as const

  constructor(
    readonly groups: Record<EquipmentGroupStId, OnlyElevatorsAssessmentGroup>,
    readonly errors: AssessmentErrors
  ) {}
}
export class ValidForGSMCampaign {
  // TODO: Remove as part of GSM Clean up
  readonly _tag: 'ValidForGSMCampaign' = 'ValidForGSMCampaign' as const

  constructor(
    readonly groups: Record<EquipmentGroupStId, OnlyElevatorsAssessmentGroup>,
    readonly errors: AssessmentErrors
  ) {}
}
export interface OnlyElevatorsAssessmentGroup {
  readonly groupId: EquipmentGroupStId
  readonly name: string
  // support for grouping view. This can still have only Elevators
  readonly groupKind: 'elevators_and_escalators'
  readonly elevators: Elevator[]
}

export class ValidForQuickTender {
  readonly _tag: 'ValidForQuickTender' = 'ValidForQuickTender' as const

  constructor(
    readonly groups: Record<EquipmentGroupStId, OnlyElevatorsAssessmentGroup>,
    readonly errors: AssessmentErrors
  ) {}
}

export class Invalid {
  readonly _tag: 'Invalid' = 'Invalid' as const

  constructor(readonly errors: AssessmentErrors) {}
}

export type AssessmentResult =
  | Invalid
  | ValidForQuickTender
  | ValidForFlexible
  | ValidForFlexibleDoors
  | ValidForValueAddedServiceAddendum
  | ValidForGSMCampaign // TODO: Remove as part of GSM Clean up
